import React from 'react'
import {
  AboutDetails,
  ContestModalWrapper,
  DetailsWrapper,
  ImageWrapper,
  TextContainer,
} from './style'
import { useTypedSelector } from 'src/redux/index'
import { useParams } from 'react-router-dom'
import { addNairaSign } from 'src/utils/addNairaSign'
import {
  ContestDateSvg,
  ContestAmountSvg,
  ContestInterestSvg,
} from 'src/assets'
import { ContestModalTitle } from 'src/components/Global/Text/TitleText'

const About = () => {
  const params = useParams()
  const { id } = params
  const userContest = useTypedSelector((state) => state.xcontest.userContests)

  const data = userContest.filter((item: any) => item?.contest_id === id)

  console.log(data)

  const { amount_to_save, end_date, plan } = data[0]

  const { accrued_interest } = plan
  return (
    <ContestModalWrapper>
      <ContestModalTitle>About</ContestModalTitle>

      <AboutDetails>
        <DetailsWrapper>
          <ImageWrapper>
            <img src={ContestAmountSvg} alt="" />
          </ImageWrapper>
          <TextContainer>
            <p className="amount_text">Auto Debit Amount</p>
            <p className="amount_text">{addNairaSign(amount_to_save)}</p>
          </TextContainer>
        </DetailsWrapper>
        <DetailsWrapper>
          <ImageWrapper>
            <img src={ContestDateSvg} alt="" />
          </ImageWrapper>
          <TextContainer>
            <p className="date_text">Target Date</p>
            <p className="date_text">{end_date}</p>
          </TextContainer>
        </DetailsWrapper>
        <DetailsWrapper>
          <ImageWrapper>
            <img src={ContestInterestSvg} alt="" />
          </ImageWrapper>
          <TextContainer>
            <p className="interest_text">Interest Earned</p>
            <p className="interest_text">{addNairaSign(accrued_interest)}</p>
          </TextContainer>
        </DetailsWrapper>
      </AboutDetails>
    </ContestModalWrapper>
  )
}

export default About
